import { CurrencyEuroIcon, DashboardIcon, UsersIcon } from 'vue-tabler-icons';

export interface Menu {
  title: string;
  icon: object;
  to: string;
}

const horizontalItems: Menu[] = [
  {
    title: 'Allgemein',
    icon: DashboardIcon,
    to: '/'
  },
  {
    title: 'Finanzen',
    icon: CurrencyEuroIcon,
    to: '/finance'
  },
  {
    title: 'Personal',
    icon: UsersIcon,
    to: '/staff'
  }
];

export default horizontalItems;
